export default {
    'diagram3b4-1': {
        'diagram-task': 'Inductive',
        'diagram-peak': 'Policy uncertainty is bad for business',
        'diagram-hint': 'Why?',
        'diagram-answers': {
            '1': 'Causes GDP to fall',
            '2': 'Companies invest less, trade less, hire fewer people',
            '3': 'Consumers spend less',
            '4': 'Paralyzes both government and business responses',
            '5': 'Business less sensitive to outside forces',
            '6': 'Firms slow to expand or contract',
            '7': 'Harms productivity',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b4/diagram1/i18n/en.js